<div class="row">
  <div class="col-12">
    <button (click)="createAcces()" class="btn q-btn q-main mr-2" [disabled]="isDisabled()" title="Créer les accès"><i class="far fa-save mr-2"></i>Générer les accès</button>  
    <button (click)="open(ModalSendMailValidation)" class="btn q-btn q-main" [disabled]="isDisabled()" title="Envoyer un email de connexion pour chaque accès"><i class="far fa-paper-plane mr-2"></i>Envoyer les accès</button>
    <button (click)="open(ModalDeleteValidation)" class="btn q-btn q-danger mr-2" [disabled]="isDisabled()" title="Supprimer les accès"><i class="far fa-trash-alt mr-2"></i>Supprimer les accès</button>
    <i class="fas fa-question-circle" placement="right" [ngbTooltip]="tipContentQcnx" ></i>
  </div> 
</div>

<div class="d-flex flex-wrap effectif-container my-2">
  <q-effectifs class="col-12 col-md-6 col-xl h-100 my-2" [Option]="OptionStagiaire" [RefreshEffectif]="service.RefreshEffectif" [NeedInfoExtranet]="true" (EffectifToEmit)="updateListPersonne($event, 'APPRENANT')" [ListEffectifChecked]="getListSelected('APPRENANT')">    
    <ng-template let-Effectif #mytemplate>
      <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
      <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
      <div *ngIf="Effectif.HasExtranetAcces else noAccess">
        <a href="{{Effectif.UrlExtranetAcces}}" target="_blank"><i class="fas fa-sign-in-alt q-c-success" title="Accéder à l'Extranet"></i></a>
      </div>
      <ng-template #noAccess><div><i class="fas fa-times q-c-danger"></i></div></ng-template>


      <div *ngIf="Effectif.ExtranetMailSend else mailSend">
        <div><i class="fa-regular fa-paper-plane q-c-success" title="Identifiant extranet envoyé par mail"></i></div>
      </div>
      <ng-template #mailSend><div><i class="fa-regular fa-paper-plane q-c-danger" title="Identifiant extranet non envoyé par mail"></i></div></ng-template>

    </ng-template>
  </q-effectifs>
  <q-effectifs class="col-12 col-md-6 col-xl h-100 my-2" [Option]="OptionFormateur" [RefreshEffectif]="service.RefreshEffectif" [NeedInfoExtranet]="true" (EffectifToEmit)="updateListPersonne($event, 'FORMATEUR')">
    <ng-template let-Effectif #mytemplate>
      <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
      <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
      <div *ngIf="Effectif.HasExtranetAcces else noAccess">
        <a href="{{Effectif.UrlExtranetAcces}}" target="_blank"><i class="fas fa-sign-in-alt q-c-success" title="Accéder à l'Extranet"></i></a>
      </div>
      <ng-template #noAccess><div><i class="fas fa-times q-c-danger"></i></div></ng-template>



      <div *ngIf="Effectif.ExtranetMailSend else mailSend">
        <div><i class="fa-regular fa-paper-plane q-c-success" title="Identifiant extranet envoyé par mail"></i></div>
      </div>
      <ng-template #mailSend><div><i class="fa-regular fa-paper-plane q-c-danger" title="Identifiant extranet non envoyé par mail"></i></div></ng-template>


    </ng-template>
  </q-effectifs>
  <q-effectifs class="col-12 col-md-6 col-xl h-100 my-2" [Option]="OptionResponsables" [RefreshEffectif]="service.RefreshEffectif" [NeedInfoExtranet]="true" (EffectifToEmit)="updateListPersonne($event, 'RESPONSABLERH')" [ListEffectifChecked]="getListSelected('RESPONSABLERH')">
    <ng-template let-Effectif #mytemplate>
      <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
      <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
      <div *ngIf="Effectif.HasExtranetAcces else noAccess">
        <a href="{{Effectif.UrlExtranetAcces}}" target="_blank"><i class="fas fa-sign-in-alt q-c-success" title="Accéder à l'Extranet"></i></a>
      </div>
      <ng-template #noAccess><div><i class="fas fa-times q-c-danger"></i></div></ng-template>

      <div *ngIf="Effectif.ExtranetMailSend else mailSend">
        <div><i class="fa-regular fa-paper-plane q-c-success" title="Identifiant extranet envoyé par mail"></i></div>
      </div>
      <ng-template #mailSend><div><i class="fa-regular fa-paper-plane q-c-danger" title="Identifiant extranet non envoyé par mail"></i></div></ng-template>

    </ng-template>
  </q-effectifs>
</div>

<!--  MODAL de validation de la suppression des accès extranet -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer les accès extranet?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteAcces();modal.dismiss()"
              title="Supprimer les accès">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>


<!--  MODAL de validation de l'envoie des mails des accès extranet -->
<ng-template #ModalSendMailValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header d-flex flex-wrap">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h5 class="q-c-main text-center my-5">Etes-vous sûr de vouloir envoyer les emails de connexion à l'extranet?</h5>
      <p class="q-c-danger text-center">Si des contacts n'ont pas d'adresse mail renseignée, il sera impossible de leur transmettre leurs identifiants.</p>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="sendEmailAccesExtranet();modal.dismiss()"
              title="Envoyer les emails de connexion">
        Envoyer
        <i class="far fa-paper-plane"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- Tooltip -->
<ng-template #tipContentQcnx>
  <div class="w-100">
    <div class="row">
      <div class="col-12">
        <div class="rounded-corners" style="padding:5px;">
          <p><i class="fas fa-sign-in-alt q-c-success mr-2"></i>Ces contacts ont un accès extranet ouvert</p>
          <p><i class="fas fa-times q-c-danger mr-2"></i>Ces contacts n'ont pas d'accès extranet ouvert</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
